import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { merge } from 'lodash';
import { configService } from 'services/config.service';
import store from 'slices/store';
import { ThemeWrapper } from '@timeedit/ui-components';
import { defaultTheme } from '@timeedit/ui-components/theme/token';
import App from './App';
import './app/instrumentation';
// Vendored Tailwind v3 utility dump from the legacy `@timeedit/ui-components`
// v6 build. The v7 upgrade dropped this precompiled CSS, but the codebase (and
// v7's own compiled output) still references `te-*` utility classes — without
// this file those classes resolve to no-ops, breaking layout (e.g. chip rows
// stack vertically instead of flowing horizontally). Remove once the app is
// properly wired to generate the utilities via Tailwind v4.
import './assets/legacy-ui-components-tailwind.css';
import './index.css';

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

export type { TAppDispatch } from 'slices/store';

const LDProvider = await asyncWithLDProvider({
  clientSideID: configService.LAUNCH_DARKLY_CLIENT_ID,
  context: {
    kind: 'uninitialized',
    key: 'uninitialized',
  },
  options: {
    bootstrap: 'localStorage',
  },
  reactOptions: { useCamelCaseFlagKeys: false },
});

root.render(
  <ThemeWrapper
    theme={merge(defaultTheme, {
      components: { Form: { itemMarginBottom: 0 } },
    })}
    defaultComponentSize="small"
  >
    <LDProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </LDProvider>
  </ThemeWrapper>
);
